<div class="messaging-header flex flex-row justify-start items-center" *ngIf="currentChatConversation?.title">
    <!-- The Messages page has the list beside the thread and its own back control below 932px (ITP-E-194-01). -->
    <button mat-icon-button class="thread-back" (click)="navigateToConversationList()" *ngIf="!isPageHost"
            aria-label="Back to conversations"
            particleAnalytics
            analyticsCategory="conversation"
            analyticsAction="left-btn">
        <i class="fa-solid fa-angle-left" aria-hidden="true"></i>
    </button>

    <!-- CARBON'S THREAD HEADER (ITP-E-203-03): a 36px face, the name, and the address where a status word would be:
         the other person's email in a 1:1, the other members' names in a group. -->
    <div class="thread-head flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
        <span class="thread-face" aria-hidden="true">
            <collaboration-avatar *ngIf="currentChatConversation?.sourceType === 'DAC6'; else threadFace"
                                  [gravatarInfo]="currentChatConversation?.titleAvatarInfo"
                                  [showCaseAvatar]="true"
                                  [showGroupAvatar]="currentChatConversation?.isGroupConversation"></collaboration-avatar>
            <ng-template #threadFace>
                <span class="thread-faces" *ngIf="currentChatConversation?.isGroupConversation; else personFace">
                    <ngx-stored-gravatar *ngFor="let face of headerFaces; let first = first" [email]="face.email"
                                         [name]="face.name" [style]="first ? groupFaceStyle : groupFaceRingStyle"></ngx-stored-gravatar>
                </span>
                <!-- The presence dot (ITP-E-194-09, B-15) on a direct conversation's face; with no status there is none. -->
                <ng-template #personFace>
                    <messenger-presence-face [status]="headerStatus" [size]="36">
                        <ngx-stored-gravatar [email]="currentChatConversation?.titleAvatarInfo?.email"
                                             [name]="currentChatConversation?.title" [style]="faceStyle"></ngx-stored-gravatar>
                    </messenger-presence-face>
                </ng-template>
            </ng-template>
        </span>
        <div class="thread-who flex flex-col full-grow-no-shrink-no-basis">
            <div class="user-name" matTooltip="{{currentChatConversation?.title}}">{{currentChatConversation?.title}}</div>
            <div class="thread-sub" *ngIf="headerAddress as address">{{address}}</div>
        </div>
    </div>
    <div class="thread-actions flex flex-row justify-start items-center">

        <button mat-icon-button class="user-button" *ngIf="!hasLeft && callPeer && (canCall$ | async)" (click)="onCall()"
                matTooltip="Voice call" aria-label="Voice call">
            <i class="far fa-phone"></i>
        </button>
        <!-- Starts the call as a video call (ITP-E-182-05): it rings as video, and the card opens with the camera on. -->
        <button mat-icon-button class="user-button" *ngIf="!hasLeft && callPeer && (canCall$ | async)" (click)="onVideoCall()"
                matTooltip="Video call" aria-label="Video call">
            <i class="far fa-video"></i>
        </button>
        <!-- Start a Meet (ITP-E-208-01): a new Orbitax Meet for the chat, opened for this user in a new tab, its card posted
             here; nobody is rung. Orbitax Meet's licence alone shows it, not the calls switch (D-09). -->
        <button mat-icon-button class="user-button start-meet" *ngIf="!hasLeft && callPeer && (canStartMeet$ | async)"
                (click)="onStartMeet()" matTooltip="Start a Meet" aria-label="Start a Meet">
            <i class="far fa-video-plus" aria-hidden="true"></i>
        </button>
        <!-- Schedule meeting (ITP-E-208-04): the calendar's event dialog with the chat's members; the saved event's Meet is
             bound to the chat and its card posted here. Gated by Orbitax Meet (OM), as Start a Meet is. -->
        <button mat-icon-button class="user-button schedule-meeting" *ngIf="!hasLeft && callPeer && (canStartMeet$ | async)"
                (click)="onScheduleMeeting()" matTooltip="Schedule meeting" aria-label="Schedule meeting">
            <i class="far fa-calendar-plus" aria-hidden="true"></i>
        </button>
        <app-dnd-toggle *ngIf="!hasLeft && callPeer && (canCall$ | async)" variant="icon"></app-dnd-toggle>
        <ng-container *ngIf="!hasLeft && isGroupCallable">
            <ng-container *ngIf="liveGroupCall$ | async as liveCall; else groupCallButton">
                <button mat-stroked-button class="group-call-join" *ngIf="liveCall.presence === 'join'"
                        (click)="onJoinGroupCall(liveCall.card)" matTooltip="Join the call in progress" aria-label="Join call">
                    <i class="far fa-phone"></i> Join
                </button>
                <span class="group-call-status" *ngIf="liveCall.presence === 'in-call'">In call</span>
                <ng-container *ngIf="liveCall.presence === 'elsewhere'">
                    <span class="group-call-status">In this call in another tab</span>
                    <button mat-stroked-button class="group-call-join" (click)="onSwitchGroupCallHere(liveCall.card)"
                            matTooltip="Move the call into this tab" aria-label="Switch here">
                        <i class="far fa-arrow-right-to-bracket"></i> Switch here
                    </button>
                </ng-container>
            </ng-container>
            <ng-template #groupCallButton>
                <button mat-icon-button class="user-button" *ngIf="canCall$ | async" (click)="onCallGroup()"
                        matTooltip="Call the group" aria-label="Call the group">
                    <i class="far fa-phone"></i>
                </button>
                <button mat-icon-button class="user-button" *ngIf="canCall$ | async" (click)="onVideoCallGroup()"
                        matTooltip="Video call the group" aria-label="Video call the group">
                    <i class="far fa-video"></i>
                </button>
            </ng-template>
            <!-- Start a Meet (ITP-E-208-01) in a group: its own meeting, whether or not a group call is live (D-02). -->
            <button mat-icon-button class="user-button start-meet" *ngIf="canStartMeet$ | async" (click)="onStartMeet()"
                    matTooltip="Start a Meet" aria-label="Start a Meet">
                <i class="far fa-video-plus" aria-hidden="true"></i>
            </button>
            <!-- Schedule meeting (ITP-E-208-04) in a group: the calendar's event dialog with the group's members. -->
            <button mat-icon-button class="user-button schedule-meeting" *ngIf="canStartMeet$ | async" (click)="onScheduleMeeting()"
                    matTooltip="Schedule meeting" aria-label="Schedule meeting">
                <i class="far fa-calendar-plus" aria-hidden="true"></i>
            </button>
        </ng-container>
        <!-- Search in the conversation (ITP-E-204-09): an icon in the Messages page header, as carbon's (page.tsx:588-590);
             the panel keeps it in ⋯. -->
        <button mat-icon-button class="user-button thread-tool" *ngIf="isPageHost && canSearchThread" (click)="toggleHeaderSearch()"
                [class.search-open]="searchOpen" [attr.aria-pressed]="searchOpen"
                matTooltip="Search in conversation" aria-label="Search in conversation">
            <i class="far fa-magnifying-glass" aria-hidden="true"></i>
        </button>
        <!-- The Messages page's Details (ITP-E-194-02): page only. The page opens it in the right sidebar's Details panel
             and closes it again; pressed while the sidebar shows it (ITP-E-204-01). -->
        <button mat-icon-button class="user-button thread-tool" *ngIf="isPageHost" (click)="detailsToggled.emit()"
                [class.details-open]="detailsOpen" [attr.aria-pressed]="detailsOpen"
                [matTooltip]="detailsOpen ? 'Hide details' : 'Show details'"
                [attr.aria-label]="detailsOpen ? 'Hide details' : 'Show details'">
            <i class="far fa-circle-info"></i>
        </button>
        <button mat-icon-button class="partipants-icon-btn" (click)="onClickXMark()" *ngIf="isFloatingView"><i
                class="fa-solid fa-xmark"></i>
        </button>
        <!-- THE ACTIONS MENU (ITP-E-203-03, Plan Q9): carbon's order with ITP's verbs (messenger/thread-menu.ts). -->
        <button mat-icon-button [matMenuTriggerFor]="chatHeaderMenu"
                *ngIf="!hideSettings && !(currentChatConversation?.sourceType && currentChatConversation?.sourceType.toLowerCase() == 'orbitaxsupport')"
                class="user-button thread-more"
                [attr.aria-label]="'Actions for ' + currentChatConversation?.title"
                particleAnalytics
                analyticsCategory="conversation"
                analyticsAction="more-btn">
            <i class="fa-regular fa-ellipsis" aria-hidden="true"></i>
        </button>

        <mat-menu #chatHeaderMenu="matMenu" xPosition="before" [overlapTrigger]="false">
            <ng-container *ngFor="let item of headerMenuItems">
                <mat-divider *ngIf="item === 'divider'"></mat-divider>
                <button mat-menu-item *ngIf="item !== 'divider'" (click)="onHeaderMenu(item)">
                    <i [class]="headerMenu[item].icon" aria-hidden="true"></i>&nbsp;<span>{{ headerMenu[item].label }}</span>
                </button>
            </ng-container>
        </mat-menu>

    </div>
</div>

<!-- The search bar (ITP-E-194-07, B-16): the text, how many matches and which one, older / newer, and close. -->
<div class="thread-search" *ngIf="canSearchThread && searchOpen" role="search">
    <i class="far fa-magnifying-glass" aria-hidden="true"></i>
    <input #threadSearchInput type="search" [ngModel]="searchText" (ngModelChange)="onSearchTextChange($event)"
           placeholder="Search in conversation" aria-label="Search in conversation"
           (keydown.enter)="onSearchEnter($event)" (keydown.escape)="closeThreadSearch()">
    <span class="thread-search-count" aria-live="polite">{{searchCountLabel}}</span>
    <button mat-icon-button class="thread-search-step" [disabled]="!searchHits.length" (click)="stepSearch(-1)"
            matTooltip="Older match" aria-label="Older match">
        <i class="far fa-chevron-up"></i>
    </button>
    <button mat-icon-button class="thread-search-step" [disabled]="!searchHits.length" (click)="stepSearch(1)"
            matTooltip="Newer match" aria-label="Newer match">
        <i class="far fa-chevron-down"></i>
    </button>
    <button mat-icon-button class="thread-search-step" (click)="closeThreadSearch()" matTooltip="Close search"
            aria-label="Close search">
        <i class="far fa-xmark"></i>
    </button>
</div>

<!-- THE GROUP'S MEMBERS | ADD PANES (ITP-E-203-05): swapped in over the thread from the actions menu, panel only. -->
<chat-group-members-panes *ngIf="membersOpen && currentChatConversation?.isGroupConversation && !isPageHost"
                          [conversation]="currentChatConversation" [me]="currentUser?.email" [maxPermission]="maxPermission"
                          (back)="membersOpen = false" (removeMember)="removeGroupMember($event)"
                          (addMember)="addGroupMember($event)" (leave)="leaveConversation()"
                          (changeRole)="changeGroupMemberRole($event)"></chat-group-members-panes>

<!-- THE BAND (ITP-E-203-03, carbon `.itp-chat-band`): one strip between the header and the messages, holding the
     selection's controls or the starred view. The search above is the third mode; only one is ever open. -->
<div class="thread-band" *ngIf="band === 'select'">
    <label class="thread-band__all">
        <input type="checkbox" class="chat-check" [checked]="allSelected"
               [indeterminate]="selectedIds.size > 0 && !allSelected" (change)="selectAll($any($event.target).checked)">
        <span class="thread-band__label">Select all</span>
    </label>
    <button mat-icon-button class="thread-band__close" (click)="closeBand()" aria-label="Close selection"
            matTooltip="Close selection"><i class="fa-regular fa-xmark" aria-hidden="true"></i></button>
</div>
<div class="thread-band" *ngIf="band === 'starred'">
    <span class="thread-band__label thread-band__title">Starred messages</span>
    <button mat-icon-button class="thread-band__close" (click)="closeBand()" aria-label="Close starred messages"
            matTooltip="Close starred messages"><i class="fa-regular fa-xmark" aria-hidden="true"></i></button>
</div>

<!-- The pinned bar (ITP-E-194-06, B-13, carbon's `.itp-msgr-pinned`): the pin it shows, which a click scrolls to and
     lights; with more than one, each click moves the bar on to the next. -->
<button type="button" class="pinned-bar" *ngIf="canPin && currentPin as pin" (click)="onPinnedBarClick()"
        [attr.aria-label]="'Pinned message: ' + pin.text + '. Go to the message.'">
    <i class="fa-solid fa-thumbtack" aria-hidden="true"></i>
    <span class="pinned-bar-label">Pinned</span>
    <span class="pinned-bar-text">{{pin.text}}</span>
    <!-- Carbon's count, after the text and in the bar's quiet ink (ChatPanel.tsx:3913-3916, ITP-E-204-11). -->
    <span class="pinned-bar-count" *ngIf="pinnedMessages.length > 1">{{pinnedMessages.indexOf(pin) + 1}} of {{pinnedMessages.length}}</span>
</button>

<section class="hide meet-chat-empty-section">
    <h1>
        <span class="highlighted-text">Welcome to Orbitax Meet</span>
        <span>How can I help you today?</span>
    </h1>
    <mat-list>
        <mat-list-item>
            <div class="icon-container" matListItemIcon><i class="fa-regular fa-user-plus"></i></div>
            <div matListItemTitle>I want to add further participants</div>
            <div matListItemLine>Invite team members to join this meeting</div>
        </mat-list-item>

        <mat-list-item>
            <div class="icon-container" matListItemIcon><i class="fa-regular fa-align-left"></i></div>
            <div matListItemTitle>I want you to transcribe this call</div>
            <div matListItemLine>XatBot will summarize the discussion</div>
        </mat-list-item>
        <mat-list-item>
            <div class="icon-container" matListItemIcon><i class="fa-regular fa-play"></i></div>
            <div matListItemTitle>Guide us through the platform</div>
            <div matListItemLine>XatBot will guide you through a demonstration</div>
        </mat-list-item>

        <mat-list-item>
            <div class="icon-container" matListItemIcon><i class="fa-regular fa-list-check"></i></div>
            <div matListItemTitle>Create and assign tasks from this call</div>
            <div matListItemLine>XatBot will assign tasks to required users</div>
        </mat-list-item>
    </mat-list>
</section>
<div
        *ngIf="currentChatConversation?.sourceType && currentChatConversation?.sourceType.toLowerCase() == 'orbitaxsupport'"
        class="whom-is-chat-with flex flex-row justify-start items-center cursor-pointer" (click)="navigateToSourceOfChat()">
    You are chatting about Help & Support Ticket ({{currentChatConversation?.sourceInfo?.sourceInfoDictionary[0]?.Value}})
</div>
<div #messagecontainer class="rest-of simple-scroll">

    <!-- OLDER MESSAGES LOAD AS YOU SCROLL UP (ITP-E-240-11, like WhatsApp): no link. Near the top the next page comes by
         itself; while it loads a small spinner shows, and a page that failed says so with Try again. Both sit in a sticky
         strip of no height over the top of the thread, so neither moves a row. -->
    <div class="older-page-strip" *ngIf="loadingOlderMessages || olderPageFailed">
        <span class="older-page-spinner" *ngIf="loadingOlderMessages; else olderPageFailedLine" role="status"
              aria-label="Loading older messages"><i class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></i></span>
        <ng-template #olderPageFailedLine>
            <span class="older-page-failed" role="alert">Couldn't load older messages.
                <button type="button" class="older-page-retry" (click)="loadOlderMessages()">Try again</button>
            </span>
        </ng-template>
    </div>
    <!-- The Starred band (ITP-E-204-06) filters what is loaded; it pages a starred message older than those in by itself,
         and says so once nothing starred can show. -->
    <div class="chat-empty-line" *ngIf="starredState === 'none-starred'" role="status">No starred messages.</div>
    <ng-container *ngFor="let messageObj of messages; let i = index">
    <!-- The unread divider (ITP-E-194-08, carbon's `.itp-msgr-unread`): before the first message unread on opening. -->
    <div *ngIf="unreadDivider && unreadDivider.messageId === messageObj.id" class="unread-divider" role="separator"
         [attr.aria-label]="unreadDividerLabel">
        <span>{{unreadDividerLabel}}</span>
    </div>
    <!-- The day, said once where it changed, and only when the thread spans more than one (ITP-E-203-06). -->
    <div *ngIf="band !== 'starred' && dayLabels[i] as day" class="day-separator" role="separator" [attr.aria-label]="day">{{day}}</div>
    <div class="message-container" *ngIf="band !== 'starred' || isStarred(messageObj)"
         (mouseover)="messageObj.hover=true" (mouseleave)="messageObj.hover=false">

        <div *ngIf="messageObj.isDeleted" class="deleted-text message-box" [ngClass]="messageObj.isMine ? 'me' : 'others'">
            <i class="fa-regular fa-ban" aria-hidden="true"></i><span [id]="messageObj.sequence">This message was deleted</span>
        </div>

        <div *ngIf="messageObj.isSystemMessage && !messageObj.callInvitationId" class="system-msg message-box flex flex-row justify-center items-start">
            <span [innerHtml]="messageObj.message" [id]="messageObj.sequence"></span>
        </div>

        <!-- A call row (D-18, ITP-E-189-11): the caller's own message, in their column, worded from the call. Shown as the
             card alone, no bubble around it (ITP-E-189-13). Reply, Delete and read ticks as for any message; never Edit.
             Who placed the call is said above it, "You" or the caller's name, in every chat (ITP-E-240-07, Q23). -->
        <div *ngIf="!messageObj.isDeleted && messageObj.callInvitationId" class="call-row"
             [ngClass]="messageObj.isMine ? 'mine' : 'theirs'">
            <span class="call-row-caller" *ngIf="callRowCallerOf(messageObj) as caller">{{caller}}</span>
            <div class="call-row-body">
                <app-call-card [id]="messageObj.sequence" [message]="messageObj" [conversationId]="currentChatConversation?.id"
                               [isGroup]="!!currentChatConversation?.isGroupConversation"
                               [title]="currentChatConversation?.title"></app-call-card>
            </div>
            <div class="call-row-meta flex flex-row justify-end items-center">
                <button mat-icon-button [matMenuTriggerFor]="callMenu" *ngIf="!hasLeft" class="reply-menu call-row-menu" aria-label="Message options"
                        particleAnalytics analyticsCategory="conversation" analyticsAction="more-btn">
                    <i class="fal fa-ellipsis-h"></i>
                </button>
                <span class="timing">{{messageObj.createdDate | timeAgo}}</span>
                <div *ngIf="messageObj.isMine">
                    <i *ngIf="messageObj.readStatus === 'AllRead'" class="fal fa-check-double all-seen"></i>
                    <i *ngIf="!messageObj.readStatus || messageObj.readStatus === 'Unread'" class="fal fa-check not-seen"></i>
                    <i *ngIf="messageObj.readStatus === 'SomeRead'" class="fal fa-check partically-seen"></i>
                </div>
                <mat-menu #callMenu="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item (click)="replyMessage(messageObj)">
                        <span>Reply</span>
                    </button>
                    <button mat-menu-item (click)="removeMessage(messageObj, false)">
                        <span>Delete Message (for me)</span>
                    </button>
                    <button mat-menu-item *ngIf="windowActions(messageObj).deleteForEveryone" (click)="removeMessage(messageObj, true)">
                        <span>Delete Message (for everyone)</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <!-- A message (ITP-E-194-05, carbon's run): the sender's name once per run, the bubble with its react and actions
             controls on the free side, and the reactions under it. A card row (ITP-E-240-06) is the same row with its card
             where the bubble would be. The reaction bar is not in the row: it opens over the thread (#reactionBar). -->
        <div *ngIf="!messageObj.isDeleted && !messageObj.isSystemMessage && !messageObj.callInvitationId"
             class="message-row" [ngClass]="messageObj.isMine ? 'mine' : 'theirs'"
             [class.run-first]="isRunStart(i)" [class.run-last]="isRunEnd(i)"
             [attr.data-message-id]="messageObj.id" [class.highlighted]="highlightedMessageId === messageObj.id"
             [class.search-current]="currentSearchHitId === messageObj.id">
            <span class="message-sender" *ngIf="showSender(i)">{{senderLineOf(messageObj)}}</span>

            <div class="bubble-row" [class.picking]="band === 'select'"
                 (click)="pickOnClick(messageObj)">
                <input *ngIf="band === 'select' && canSelect(messageObj)" type="checkbox" class="chat-check"
                       [checked]="selectedIds.has(messageObj.id)" (click)="$event.stopPropagation()"
                       (change)="toggleSelected(messageObj)" [attr.aria-label]="'Select the message'">
                <!-- A card row (ITP-E-240-06): the card alone, no bubble and no sentence, as Google Chat shows a Meet. Its header
                     says who did what, and it carries the anchor a reply jumps to. The stored text is not drawn here; it
                     stays for the list preview, search, notifications and a reply's quote. -->
                <messenger-message-card *ngIf="standaloneCardOf(messageObj) as card" class="message-card-slot card-row-card"
                                        [id]="messageObj.sequence" [card]="card"
                                        [header]="cardHeaderOf(messageObj)"></messenger-message-card>
                <div *ngIf="!standaloneCardOf(messageObj)" [ngClass]="messageObj.isMine ? 'message-box me' : 'message-box others'">
                    <!-- ITP-E-193-02/03 in ITP-E-194's quote: a reply to a call row quotes the call as a small read-only card (no
                         Join), and every quote goes to the message it answers. -->
                    <!-- ITP-E-249-06 (B-25): a quoted voice message has no text: it reads "Voice message (0:42)" by its mark. -->
                    <div class="message-quote reply-jump" *ngIf="messageObj?.replyTo?.message || messageObj?.replyTo?.callInvitationId || voiceWordsOf(messageObj?.replyTo)"
                         [class.reply-call]="!!messageObj?.replyTo?.callInvitationId"
                         role="button" tabindex="0" aria-label="Go to the message"
                         (click)="goToRepliedMessage(messageObj.replyTo, $event)"
                         (keydown.enter)="goToRepliedMessage(messageObj.replyTo, $event)"
                         (keydown.space)="goToRepliedMessage(messageObj.replyTo, $event)">
                        <span class="message-quote-who">{{messageObj?.replyTo?.createdBy?.email === currentUser.email ? 'You' :
                            (messageObj?.replyTo?.createdBy?.firstName + ' ' + (messageObj?.replyTo?.createdBy?.lastName || ''))}}</span>
                        <app-call-card *ngIf="messageObj?.replyTo?.callInvitationId; else quoteText" [compact]="true"
                                       [message]="messageObj.replyTo" [conversationId]="currentChatConversation?.id"></app-call-card>
                        <ng-template #quoteText>
                            <span class="message-quote-text" *ngIf="voiceWordsOf(messageObj.replyTo) as words; else quoteHtml">{{words}}</span>
                            <ng-template #quoteHtml>
                                <span class="message-quote-text" [innerHtml]="convertMarkdownToHtml(messageObj.replyTo.message)"></span>
                            </ng-template>
                        </ng-template>
                    </div>
                    <!-- A voice message (ITP-E-249-01, B-25): its voice bubble, in place of the files. The time, the tick and
                         the star and pin marks stay in the meta row under it, and the reactions under the bubble. The Sending
                         message (ITP-E-249-02) is the sender's own, before the server has said who sent it. -->
                    <!-- ITP-E-249-05: the bubble names its message, so someone else's shows the unplayed dot until played. -->
                    <messenger-voice-bubble *ngIf="voiceOf(messageObj) as voice" class="message-voice" [file]="voice"
                                            [mine]="(messageObj.isTemporary && messageObj.isMine) || messageObj?.createdBy?.email === currentUser.email"
                                            [messageId]="messageObj.isTemporary ? null : messageObj.id"
                                            [conversationId]="currentChatConversation?.id"></messenger-voice-bubble>
                    <!-- The message's files (ITP-E-194-10): file cards and image previews, above the text. An attachment
                         whose HTML cannot be read as files renders as it always has. -->
                    <div class="message-files" *ngIf="filesOf(messageObj) as files; else rawAttachment">
                        <messenger-file-card *ngFor="let file of files" [file]="file"
                                             [mine]="messageObj?.createdBy?.email === currentUser.email"></messenger-file-card>
                    </div>
                    <ng-template #rawAttachment>
                        <div class="flex flex-row" *ngIf="messageObj?.attachment">
                            <span class="reply-text me m-t-10" *ngIf="messageObj?.createdBy?.email === currentUser.email"
                                  [innerHtml]="messageObj.attachment">
                            </span>
                            <span class="reply-text others m-t-10" *ngIf="messageObj?.createdBy?.email !== currentUser.email"
                                  [innerHtml]="messageObj.attachment">
                            </span>
                        </div>
                    </ng-template>

                    <div class="message-text">
                        <span class="message-words" [innerHtml]="searchMarkupOf(messageObj) ?? convertMarkdownToHtml(messageObj.message)" [id]="messageObj.sequence"></span>
                        <!-- The time floats into the text's last line (ITP-E-203-06, carbon `.itp-chat-bubble__time`), with
                             "edited" ahead of it as carbon has it (ChatPanel.tsx:4572, ITP-E-204-11). -->
                        <span class="message-meta">
                            <span *ngIf="messageObj.isEdited && messageObj.createdBy?.firstName != 'XatBot'" class="message-edited">edited</span>
                            <!-- Starred (B-12) and pinned (B-13) marks, ITP-E-194-06. -->
                            <i *ngIf="canPin && isPinned(messageObj)" class="fa-solid fa-thumbtack message-mark"
                               role="img" aria-label="Pinned" matTooltip="Pinned"></i>
                            <i *ngIf="canStar && isStarred(messageObj)" class="fa-solid fa-star message-mark"
                               role="img" aria-label="Starred" matTooltip="Starred"></i>
                            <span class="timing">{{messageObj.createdDate | timeAgo}}</span>
                            <!-- The delivery tick (ITP-E-194-08, carbon's `.itp-msgr-tick`): sending, sent, delivered (B-17), read. -->
                            <i *ngIf="tickFor(messageObj) as tick" class="message-tick" [ngClass]="[messageTicks[tick].icon, 'message-tick--' + tick]"
                               role="img" [attr.aria-label]="messageTicks[tick].label" [matTooltip]="messageTicks[tick].label"></i>
                        </span>
                        <span *ngIf="messageObj.data && messageObj.data[0]">
                            <button (click)="onRevertToOldValue(messageObj.data[0])" class="revert-value">
                              Revert
                            </button>
                        </span>
                        <!-- This user's own message shows Sending as its tick instead (ITP-E-194-08). -->
                        <div class="chat-spinner" *ngIf="messageObj.isTemporary && !messageObj.isMine && messageObj.createdBy?.firstName != 'XatBot'">
                            <div class="bounce1"></div>
                            <div class="bounce2"></div>
                            <div class="bounce3"></div>
                        </div>
                        <div class="chat-spinner-xatbot-messsage" *ngIf="messageObj.isTemporary && messageObj.createdBy?.firstName == 'XatBot'">
                            <div class="bounce1"></div>
                            <div class="bounce2"></div>
                            <div class="bounce3"></div>
                        </div>
                    </div>

                </div>

                <div class="message-actions flex flex-row items-center" *ngIf="!hasLeft && band !== 'select'"
                     [style.visibility]="messageObj.isTemporary ? 'hidden': 'visible'">
                    <button mat-icon-button class="message-action message-react" *ngIf="canReact(messageObj)"
                            (click)="toggleReactionPicker(messageObj, $any($event.currentTarget))" [class.open]="reactingTo === messageObj.id"
                            [attr.aria-expanded]="reactingTo === messageObj.id" matTooltip="React" aria-label="React to the message">
                        <i class="fa-solid fa-face-smile" aria-hidden="true"></i>
                    </button>
                    <button mat-icon-button class="message-action" [matMenuTriggerFor]="msgMenu" aria-label="Message options"
                            particleAnalytics
                            analyticsCategory="conversation"
                            analyticsAction="more-btn">
                        <i class="fa-solid fa-ellipsis" aria-hidden="true"></i>
                    </button>
                </div>
            </div>

            <!-- A card row's marks, time and tick (ITP-E-240-06): a small line under the card, as a call row has it. -->
            <div class="card-row-meta" *ngIf="standaloneCardOf(messageObj)">
                <i *ngIf="canPin && isPinned(messageObj)" class="fa-solid fa-thumbtack message-mark"
                   role="img" aria-label="Pinned" matTooltip="Pinned"></i>
                <i *ngIf="canStar && isStarred(messageObj)" class="fa-solid fa-star message-mark"
                   role="img" aria-label="Starred" matTooltip="Starred"></i>
                <span class="timing">{{messageObj.createdDate | timeAgo}}</span>
                <i *ngIf="tickFor(messageObj) as tick" class="message-tick" [ngClass]="[messageTicks[tick].icon, 'message-tick--' + tick]"
                   role="img" [attr.aria-label]="messageTicks[tick].label" [matTooltip]="messageTicks[tick].label"></i>
            </div>

            <!-- The message's card (ITP-E-194-10, B-20): a meeting, calendar event, Show or mission, under the bubble of a
                 message that is not a card row. -->
            <messenger-message-card *ngIf="!standaloneCardOf(messageObj) && cardOf(messageObj) as card" class="message-card-slot"
                                    [card]="card"></messenger-message-card>

            <div class="message-reactions" *ngIf="reactionsOf(messageObj).length" [class.picking]="band === 'select'">
                <button type="button" class="message-reaction" *ngFor="let reaction of reactionsOf(messageObj)"
                        [class.mine]="reaction.mine" [attr.aria-pressed]="reaction.mine" [disabled]="!canPressReaction(reaction)"
                        [attr.aria-label]="reaction.emoji + ' ' + reaction.count + (reaction.mine ? ', including you' : '')"
                        [matTooltip]="reactedBy(reaction)" (click)="react(messageObj, reaction.emoji)">
                    <span class="message-reaction-glyph" aria-hidden="true">{{reaction.emoji}}</span>
                    <span class="message-reaction-count">{{reaction.count}}</span>
                </button>
            </div>

            <mat-menu #msgMenu="matMenu" [overlapTrigger]="false">
                <!-- Carbon's order and glyphs (ITP-E-203-06): Reply, Forward, Star, Pin, Message info, Edit, then the deletes
                     after a divider. Each item keeps today's rule and flag. -->
                <button mat-menu-item (click)="replyMessage(messageObj)">
                    <i class="fa-regular fa-reply" aria-hidden="true"></i>&nbsp;<span>Reply</span>
                </button>
                <!-- Forward (B-11), Star (B-12), Pin (B-13): ITP-E-194-06, each only while its flag is on. Never Forward on a
                     card row: the server refuses it (ITP-E-207-05, ITP-E-240-06). -->
                <button mat-menu-item *ngIf="canForwardMessage(messageObj)" (click)="forwardMessage(messageObj)">
                    <i class="fa-regular fa-share" aria-hidden="true"></i>&nbsp;<span>Forward</span>
                </button>
                <button mat-menu-item *ngIf="canStar && canActOn(messageObj)" (click)="toggleStar(messageObj)">
                    <i [class]="isStarred(messageObj) ? 'fa-solid fa-star' : 'fa-regular fa-star'" aria-hidden="true"></i>&nbsp;<span>{{isStarred(messageObj) ? 'Unstar' : 'Star'}}</span>
                </button>
                <button mat-menu-item *ngIf="canPin && canActOn(messageObj)" (click)="togglePin(messageObj)">
                    <i class="fa-regular fa-thumbtack" aria-hidden="true"></i>&nbsp;<span>{{isPinned(messageObj) ? 'Unpin' : 'Pin'}}</span>
                </button>
                <!-- Message info (B-14), ITP-E-194-07: who received and read this user's own message. -->
                <button mat-menu-item *ngIf="canShowInfo && messageObj.isMine && canActOn(messageObj)" (click)="showMessageInfo(messageObj)">
                    <i class="fa-regular fa-circle-info" aria-hidden="true"></i>&nbsp;<span>Message info</span>
                </button>
                <!-- A card row (B-20) is never edited, as a call row is not (ITP-E-208-02). In a chat, Edit and Delete for everyone
                     follow the server's windows for this reader (ITP-E-207-08, messenger/message-windows.ts). A voice message
                     (ITP-E-249-06) has no text to edit: never Edit, even before the server has answered canEdit for it. -->
                <button mat-menu-item *ngIf="windowActions(messageObj).edit && !messageObj.isInitialMessage && !messageObj.data && !messageObj.card?.kind && !isVoiceMessage(messageObj)"
                        (click)="editMessage(messageObj)">
                    <i class="fa-regular fa-pen" aria-hidden="true"></i>&nbsp;<span>Edit</span>
                </button>
                <mat-divider *ngIf="!messageObj.isInitialMessage && !messageObj.data"></mat-divider>
                <button mat-menu-item *ngIf="!messageObj.isInitialMessage && !messageObj.data"
                        (click)="removeMessage(messageObj, false)">
                    <i class="fa-regular fa-trash-can" aria-hidden="true"></i>&nbsp;<span>Delete for me</span>
                </button>
                <button mat-menu-item class="message-menu-danger" *ngIf="windowActions(messageObj).deleteForEveryone && !messageObj.isInitialMessage && !messageObj.data"
                        (click)="removeMessage(messageObj, true)">
                    <i class="fa-regular fa-trash-can" aria-hidden="true"></i>&nbsp;<span>Delete for everyone</span>
                </button>
            </mat-menu>
        </div>
    </div>
    </ng-container>
    <!--  <div class="chat-spinner" *ngIf="displaySpinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>-->
</div>

<!-- Who is typing (ITP-E-194-08, B-18, carbon's `.itp-msgr-typing`): the line is kept, so the thread does not jump. -->
<div class="typing-line" *ngIf="canShowTyping && !hasLeft" aria-live="off">
    <ng-container *ngIf="typingLabel as label">
        <span class="typing-dots" aria-hidden="true"><span></span><span></span><span></span></span>{{label}}
    </ng-container>
</div>

<!-- THE SELECTION'S FLOOR (ITP-E-203-03): how many are picked, and Delete (for me) once one is. -->
<div class="select-floor" *ngIf="band === 'select'">
    <span class="select-floor__count" aria-live="polite">{{ selectionText }}</span>
    <button mat-flat-button class="select-floor__delete" *ngIf="selectedIds.size" (click)="deleteSelected()">Delete</button>
</div>

<!-- LEFT (ITP-E-204-05): where the composer was, why there is none. The conversation stays readable after leaving. -->
<div class="select-floor select-floor--left" *ngIf="hasLeft && band !== 'select'" role="status">You left this conversation.</div>

<particle-chat-editor
        *ngIf="!hasLeft" [class.is-hidden]="band === 'select'"
        [editorId]="'conversation-textarea'"
        [text]="chatText"
        [allContacts]="allContacts"
        [hideDac6CardLink]="true"
        [plusMenu]="true"
        [plusPeople]="!!currentChatConversation?.isGroupConversation"
        [assistants]="assistantsInConversation"
        (scheduleMeeting)="onScheduleMeeting()"
        [replyToMessage]="replyToMessage"
        [attachmentConversationId]="chatFilesConversationId"
        [focusEditor$]="focusEditorOnChatEditor$"
        [placeholder]="currentChatConversation?.waitingMessage?currentChatConversation?.waitingMessage:'Enter message...'"
        (cancelReplyEvent)="onCancelReply($event)"
        (outputChatEditorEvent)="sendMessage($event)"
        (outputEditorInnerHtmlEvent)="onEditorInnerHtmlEvent($event)"
>
</particle-chat-editor>

<!-- THE REACTION BAR (ITP-E-240-09, owner review: "like WhatsApp, up the emoji icon"): one for the thread, drawn into an
     overlay over it and anchored to the React button that opened it, above the button unless the thread's box has no
     room there. Nothing in the thread moves when it opens or closes. -->
<ng-template #reactionBar>
    <messenger-reaction-picker [choices]="reactionChoices" [anyEmoji]="canReactWithAnyEmoji" [full]="pickingAnyEmoji"
                               (picked)="reactFromPicker($event)" (more)="showEveryEmoji()"></messenger-reaction-picker>
</ng-template>
